<template>
  <div class="wrapper-bar-2">
    <div class="grid">
      <router-link
        :to="
          $i18nRoute({
            name: 'NewsDetail',
            params: { slug: item.url }
          })
        "
        v-for="(item, index) in list.slice(0, 12)"
        :key="item.id"
        class="grid__item"
      >
        <div class="card" :class="`card-${index + 1}`">
          <div class="card__category-tablet">
            {{ item.sub_category.name }}
          </div>
          <div class="flex-tablet flex-mobile">
            <div class="card__img">
              <div class="card__category">{{ item.sub_category.name }}</div>
              <ImageContainer
                style="overflow: visible; boreder-radius: 0px"
                :src="item.image.medium"
                :thumb="item.image.thumbnail"
                :alt="item.title"
              />
              <i v-if="item.video" class="fas fa-play-circle icon-player"></i>
            </div>
            <div class="card__descr">
              <div class="card__title limited-text">{{ item.title }}</div>
              <div class="data-news">
                <span class="day">{{ handleDate(item.pub_date) }},</span>
                <span class="time">{{ handleTime(item.pub_date) }}</span>
              </div>
            </div>
          </div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import { useFormatter } from "@/utils/formatter";
import ImageContainer from "@/components/ImageContainer";

export default {
  components: { ImageContainer },
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  setup() {
    return {
      ...useFormatter()
    };
  }
};
</script>

<style lang="scss" scoped>
.wrapper-bar-2 {
  position: relative;
  margin-top: 2rem;
  max-width: var(--width-media);
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: var(--primary-font-color);
    z-index: 2;
    @media screen and (max-width: 992px) {
      display: none;
    }
  }
  @media screen and (max-width: 992px) {
    margin: 1.5rem 0;
    width: 100%;
  }
  @media screen and (max-width: 767px) {
    margin: 0;
  }
}

.card {
  .limited-text {
    --snup: 4 !important;
  }

  &__title {
    margin-top: 0.5rem;
    font-family: Roboto;
    font-weight: 400;
    font-size: calc(min(19px, 1vw));
    line-height: 1.3em;
    @media screen and (max-width: 1100px) {
      font-size: calc(min(1.25em, 1.3vw));
    }

    @media screen and (max-width: 992px) {
      font-family: Roboto;
      font-style: normal;
      font-size: 16px;
      line-height: 22px;
    }
    @media screen and (max-width: 767px) {
      font-family: Roboto;
      font-size: 12px;
      line-height: 15px;
      color: var(--primary-font-color);
    }
  }
  .data-news {
    font-family: Open Sans;
    font-size: calc(min(0.9em, 0.85vw));
    line-height: 19px;
    margin-top: 8px;
    @media screen and (max-width: 992px) {
      font-family: Open Sans;
      font-size: 13px;
      line-height: 18px;
      color: var(--category-color);
    }
    @media screen and (max-width: 767px) {
      font-family: Open Sans;
      font-size: 10px;
      line-height: 14px;
    }
  }
  &__img {
    position: relative;
    border-radius: 4px;
    overflow: hidden;
    height: 11vw;
  }
  &__category {
    position: absolute;
    z-index: 3;
    font-family: Open Sans;
    font-size: 14px;
    line-height: 19px;
    color: var(--category-color);
    background: var(--secondary-font-color);
    padding: 3px;
    @media screen and (max-width: 992px) {
      font-family: Open Sans;
      font-weight: 600;
      font-size: 13px;
      line-height: 18px;
      text-transform: uppercase;
    background: var(--secondary-font-color) !important;

    }
    @media screen and (max-width: 767px) {
      font-family: Open Sans;
      font-weight: 600;
      font-size: 10px;
      line-height: 14px;
    }
  }
  .card__category-tablet {
    display: none;
    font-family: Open Sans;
    font-weight: 600;
    font-size: 13px;
    line-height: 18px;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.6);
  }
}
.grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  @media screen and (max-width: 992px) {
    gap: 2rem 1rem;
  }

  &__item {
    padding: 1.8rem;
  }
  &__item:nth-child(1),
  &__item:nth-child(5),
  &__item:nth-child(6),
  &__item:nth-child(9),
  &__item:nth-child(10),
  &__item:nth-child(11) {
    background: var(--foreground-color);
    color: var(--secondary-font-color);
    @media screen and (max-width: 992px) {
      background-color: transparent;
      color: var(--primary-font-color);
    }
    .card__category {
      background-color: var(--primary-font-color);
      @media screen and (max-width: 992px) {
        background-color: var(--black-bg);
      }
    }
  }
}
@media screen and (max-width: 992px) {
  .grid {
    grid-row: 8;

    &__item {
      padding: 0;
      grid-column: span 2;
    }
    &__item:nth-child(1),
    &__item:nth-child(2),
    &__item:nth-child(3),
    &__item:nth-child(4) {
      grid-column: 3 / span 2;
      grid-row: span 2;
      .card__img {
        height: 184px;
      }
    }

    &__item:nth-child(5),
    &__item:nth-child(6),
    &__item:nth-child(7),
    &__item:nth-child(9),
    &__item:nth-child(10),
    &__item:nth-child(11),
    &__item:nth-child(12),
    &__item:nth-child(8) {
      grid-column: 1 / span 2;
    }
    &__item:nth-child(5) {
      grid-row: 1;
    }
    &__item:nth-child(6) {
      grid-row: 2;
      transform: translateY(-15px);
    }
    &__item:nth-child(7) {
      grid-row: 3;
      transform: translateY(-25px);
    }
    &__item:nth-child(8) {
      grid-row: 4;
      transform: translateY(-40px);
    }
    &__item:nth-child(9) {
      grid-row: 5;
      transform: translateY(-55px);
    }
    &__item:nth-child(10) {
      grid-row: 6;
      transform: translateY(-60px);
    }
    &__item:nth-child(11) {
      grid-row: 7;
      transform: translateY(-70px);
    }
    &__item:nth-child(12) {
      grid-row: 8;
      transform: translateY(-100px);
    }
  }
  .card-5,
  .card-6,
  .card-7,
  .card-8,
  .card-9,
  .card-10,
  .card-11,
  .card-12 {
    display: flex;
    flex-direction: column;
    .flex-tablet {
      @media screen and (max-width: 992px) {
        display: flex;
      }
    }
    .card__descr {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding: 0 0.5rem;
      @media screen and (max-width: 767px) {
        justify-content: flex-start;
      }
    }
    .card__title {
      margin: 0;
      --snup: 3;
    }
    .card__img {
      flex: 0 0 37%;
      height: auto;
    }
    .card__category {
      display: none;
    }
    .card__category-tablet {
      display: block;
    }
  }
}
.flex-mobile {
  @media screen and (max-width: 767px) {
    display: flex;
    flex-direction: row;
    gap: 0.3rem;
  }
}
@media screen and (max-width: 767px) {
  .grid {
    display: block;
  }
  .card {
    margin-top: 20px;
    padding: 1rem 0rem;
    &__img {
      flex: 0 0 50% !important;
      height: 106px !important;
    }
    &__category-tablet {
      display: none !important;
    }
    &__category {
      display: block !important;
    }
    &__descr {
      flex: 1;
    }
  }
  .card-5 {
    .flex-mobile {
      flex-direction: row-reverse;
    }
  }
  .card-7 {
    .flex-mobile {
      flex-direction: row-reverse;
    }
  }
  .card-9 {
    .flex-mobile {
      flex-direction: row-reverse;
    }
  }

  .card-5,
  .card-6,
  .card-7,
  .card-8 {
    padding-top: 0;
    padding-bottom: 0;
    margin-top: 10px;
    .card__img {
      overflow: hidden;
      border-radius: 0px;
    }
    .card__img:deep() .main-image img {
      border-radius: 0px;
      overflow: visible;
    }
  }
  .card-4 {
    padding-top: 0;
    padding-bottom: 0;
    margin-top: 35px;
    .card__img {
      overflow: hidden;
      border-radius: 0px;
    }
    .card__img:deep() .main-image img {
      border-radius: 0px;
      overflow: visible;
    }
  }
  .card-9 {
    padding-top: 0;
    padding-bottom: 0;
    margin-top: 10px;
    margin-bottom: 35px;
    .card__img {
      overflow: hidden;
      border-radius: 0px;
    }
    .card__img:deep() .main-image img {
      border-radius: 0px;
      overflow: visible;
    }
  }
  .card-1,
  .card-2,
  .card-3,
  .card-10,
  .card-11,
  .card-12 {
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 0;
    padding-bottom: 0;
  }
}
.icon-player {
  position: absolute;
  bottom: 10px;
  left: 10px;
  font-size: 1.2rem;
  color: var(--primary-font-color);
}
</style>
